import { get, some } from 'lodash';

function targetIsIcon(e) {
  const classList = get(e, 'target.classList');
  return some(classList, (el) => el.includes('icon'));
}

export default targetIsIcon;
